<template>
  <div class="BaseTemplateLayoutGridSetting">
    <h2 class="q-mt-none q-mb-md text-cool-gray-100 fs-17px fw-500">{{ t('layout_grid.title') }}</h2>
    <BaseToggleLine
      v-model="templateStore.layoutGrid.isVisible"
      :label="t('layout_grid.show')"
      :description="t('layout_grid.description')"
    />
    <div class="BaseTemplateLayoutGridSetting__fields q-mt-md">
      <div v-for="field in GRID_FIELDS" :key="field">
        <p class="fs-15px fw-500 text-cool-gray-80 q-mb-sm">{{ t(`layout_grid.${field}`) }}</p>
        <k-input
          v-number
          small
          :model-value="templateStore.layoutGrid[field]"
          :has-clear-icon="false"
          input-class="text-center"
          @update:model-value="templateStore.setLayoutGrid(field, $event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTemplateStore } from 'src/stores'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'

defineOptions({ name: 'BaseTemplateLayoutGridSetting' })

const GRID_FIELDS = ['columns', 'gutter', 'margin']

const templateStore = useTemplateStore()
const { t } = translate(translationObject)
</script>

<style lang="sass" scoped>
@import "src/shared/styles/mixins.sass"

.BaseTemplateLayoutGridSetting
  @include element('fields')
    display: grid
    grid-template-columns: repeat(3, 1fr)
    gap: 8px
</style>
